export const OPERATIONS_STATUS = {
    LOADING: 'loading',
    LOADED: 'loaded',
    ERROR: 'error',
};

export * from './list';
